var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8143 5.6543C15.7282 5.42318 13.6289 0 7.99975 0C2.37062 0 0.268628 5.42318 0.185185 5.6543L0.0527344 6L0.185185 6.3457C0.271277 6.57682 2.37062 12 7.99975 12C13.6289 12 15.7309 6.57682 15.8143 6.3457L15.9468 6L15.8143 5.6543ZM7.99975 10.0298C4.41167 10.0298 2.67459 7.0404 2.17856 6C2.67591 4.95695 4.41366 1.9702 7.99975 1.9702C11.5858 1.9702 13.3229 4.95629 13.8209 6C13.3229 7.04371 11.5858 10.0298 7.99975 10.0298Z",
    fill: "#F2EADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99959 8.64909C9.4626 8.64909 10.6486 7.46309 10.6486 6.00008C10.6486 4.53707 9.4626 3.35107 7.99959 3.35107C6.53659 3.35107 5.35059 4.53707 5.35059 6.00008C5.35059 7.46309 6.53659 8.64909 7.99959 8.64909Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.66b3407eb69be908ef171220653006da.svg";
export { ForwardRef as ReactComponent };